import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import StudentModulesTableComp from './StudentModulesTableComp';
import ModuleTable from './ModuleTableComp';
import SideModuleTable from './SideModuleTableComp';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { toArray, arrayToObject, getPretestType, isObjectEmpty } from '../../../Utils';
import Spinner from '../../common/generic/Spinner';
import Container from 'react-bootstrap/Container';
import { TitleBar, IconEdit} from '../../common/theme';

const ProgramTitle = ({pageState, parentState})=>{
    const [programData, setProgramData] = useState({});
    const [title, setTitle] = useState('');

    const componentData = {
        programData, setProgramData,
        parentRefresh: parentState.refreshCompState, setParentRefresh: parentState.setRefreshCompState,
    };

    useEffect(() => {     
        //if(!parentState.refreshCompState) return;

        let program = componentData.programData;
        if(isObjectEmpty(program))
            program = pageState.processedProgramAssignments.find(progRec=>progRec.id.toUpperCase() === parentState.programSelectedID.toUpperCase());

        setProgramData({...program });
        setTitle(program.title);
        //parentState.setRefreshCompState(false);
    }); 

    return (
        <Container>
            <Row>  
                <Col xs='8' style={{fontWeight:'bold'}}> <h2> {title} </h2></Col> 
            </Row>            
        </Container>
    );

};
const ContainerComp = ({pageState}) =>{

    //const [programSelectedID, setProgramSelectedID] = useState('rd');
    const [studentsSelected, setStudentsSelected] = useState([]);
    const [refreshCompState, setRefreshCompState] = useState(true);
    
    const [isSaving, setIsSaving] = useState(false);
    const [requestState, setRequestState] = useState({});
    const [madeModuleChanges,setMadeModuleChanges] = useState(false);

    const componentData = {
        studentsSelected, setStudentsSelected,
        refreshCompState, setRefreshCompState,
        programSelectedID: pageState.showModulesComp,
        madeModuleChanges,setMadeModuleChanges,
        isSaving, setIsSaving, requestState: requestState, setRequestState: setRequestState
    };

    // save changes
    useEffect(()=>{
        if(isObjectEmpty(requestState)) return;
        
        let progID = requestState.progID;
        let programs = arrayToObject(pageState.rawPrograms.programs,'id');
        let schoolID = pageState.database['getCustomer'].data.ID;
        // console.log('progID',progID,pageState.rawPrograms.programs,programs);
        let progName = programs[progID].title;
        // console.log('programs[progID]',programs[progID]);
        let modules = programs[progID].modules.reduce((acc,e)=>{acc += ';'+e[0]; return acc;},'').substr(1);
        // let classID = pageState.classID;
        // let attachedID = ''; //NOTE: need to fix this with Attaching students to other teachers
        let pretestType = getPretestType(progID);

        let saveChanges = [];
        let willOverride = false;

        // remove all assignements/pretests and posttests
        if(requestState.assign==='all'){
            requestState.students.forEach(studID=>{
                saveChanges.push({debug:'RemoveAll', func:'deleteAssignment', params: `${studID}~${progName}`});
            });
        }
        
        if(requestState.assign==='assignments'){
            modules = (requestState.assignedModules!=='')?requestState.assignedModules:modules;
            requestState.students.forEach(studID=>{

                const {ClassID:classID, attachID} = toArray(pageState.database['getStudentsForClass'].data).filter(s=>s.StudentID===studID)[0];
                let attachedID = attachID?attachID:'';

                if(`${studID}+${progName}` in pageState.database['getAllClassAssignments'].data ||
                   `${studID}+${progID}` in pageState.database['getAllClassAssignments'].data)
                    willOverride = true;
    
                if(requestState.type==='add'){
                   if(programs[progID].subcateg === 'User Programs'){
                    let progIDTemp = progID.replace('~','-');
                    let type = progID.split('~')[0].split('-')[0];
                    let standard = programs[progID].standard;
                    saveChanges.push({debug:'Assignment', func:'saveUserAssignment', params: `${studID}~${progName}~${programs[progID].shortTitle}~N|${type};;${standard};;${(new Date()).getTime()}|${modules}~${classID}~${attachedID}~${schoolID}~${progIDTemp}~${programs[progID].authorID}~${programs[progID].version}~${programs[progID].productionPath}~${programs[progID].tags}`});
                   }
                   else
                    saveChanges.push({debug:'Assignment', func:'saveTeacherAssignment', params: `${studID}~${progName}~N${pretestType}${modules}~${classID}~${attachedID}~${schoolID}`});
                }else{
                    if(programs[progID].subcateg === 'User Programs'){
                        let progIDTemp = progID.replace('~','-');
                        saveChanges.push({debug:'Assignment', func:'deleteAssignment', params: `${studID}~${progIDTemp}`});
                    }
                    else
                        saveChanges.push({debug:'Assignment', func:'deleteAssignment', params: `${studID}~${progName}`});
                }
            });
        }
        if(requestState.assign==='test'){
            requestState.students.forEach(studRec=>{
                                
                let {studentID:studID, type, test} = studRec;
                if(`${studID}+${progName}` in pageState.database['getAllClassAssignments'].data ||
                    `${studID}+${progID}` in pageState.database['getAllClassAssignments'].data)
                    willOverride = true;

                const {ClassID:classID, attachID} = toArray(pageState.database['getStudentsForClass'].data).filter(s=>s.StudentID===studID)[0];
                let attachedID = attachID?attachID:'';    
    
                if(test==='posttest'){
                    if(type==='add'){
                        const date = new Date();
                        let currentTime = date.getTime();                    
                        saveChanges.push({debug:'Posttest', func:'saveTeacherAssignment', params: `${studID}~${progName}~Y_${currentTime}${pretestType}${modules}~${classID}~${attachedID}~${schoolID}`});
                    }else{
                        saveChanges.push({debug:'Posttest', func:'deleteAssignment', params: `${studID}~${progName}`});
                    }
                }
                if(test==='pretest'){
                    if(type==='add'){
                        saveChanges.push({debug:'Pretest', func:'saveTeacherAssignment', params: `${studID}~${progName}~Y${pretestType}${modules}~${classID}~${attachedID}~${schoolID}`});
                        saveChanges.push({debug:'Pretest', func:'deletePretest', params: `${studID}~${progName}`}); 
                    }else{
                        saveChanges.push({debug:'Pretest', func:'deleteAssignment', params: `${studID}~${progName}`});
                    }
                }
            });
        }   
        
        if(willOverride && !window.confirm('One or more students have a Pre-Test or a Post Test or an Assignment that will be replaced! Press ok to overwrite their assignments.'))
            return;

        // create a link list of save changes querys for saving to the database
        if(saveChanges.length > 0){
            setIsSaving(true);
            let counter = 1;
            saveChanges = saveChanges.map((query,i)=>{
                let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
                if(prevQuery !== 'undefinded'){
                    counter++;
                    query.nextRequest = prevQuery;
                }
                return query;
            });
            let saveChainedChanges = saveChanges[saveChanges.length-1];
            saveChainedChanges.numQueries = counter;
            // pass the link list of saved changes into the database
            pageState.request(saveChainedChanges); 
        }

    },[requestState]);

    // Check when saving has completed by wating for database.queryCount to become 0
    // UPDATES - database.queryCount changes -&&- only when saving
    useEffect(()=>{
        if(isSaving){
            if(pageState.database.queryCount == 0){
                setIsSaving(false);
                pageState.deleteThis('getStudentsForClass');
                pageState.deleteThis('getAllClassAssignments');
                componentData.setStudentsSelected([]);
                // pageState.setShowModulesComp('');                  
            }
        }
    },[pageState.database.queryCount]);

    // refesh the children when a new program is selected
    useEffect(() => { setRefreshCompState(true);},[pageState.showModulesComp]);

    return <>{(pageState.showModulesComp!=='') && <div><ModuleContainer pageState={pageState} componentData={componentData} /></div>}</>;

};

const ModuleContainer = ({pageState, componentData}) => {
    const hideModules = () => {
        componentData.setStudentsSelected([]);
        pageState.setShowModulesComp('');  
    };
    const showScope=()=>{
        if(componentData.programSelectedID.toLowerCase().startsWith('course'))
            return false;
        return true;
    };
    const mouseEnter=()=>pageState.setHasMouseInsideModulesPanel(true);
    const mouseLeave=()=>pageState.setHasMouseInsideModulesPanel(false);

    if((!componentData.isSaving) && pageState.database['queryCount']!==0)
        return(<><Spinner/></>);   
    return(
     <>
        <Button variant={'danger'} onClick={()=>hideModules()}>Back</Button> <br/>
        <Row>
            <Col xs={8}><ProgramTitle pageState={pageState} parentState={componentData}/> </Col>
            { showScope() && <Col xs={4}><Button variant={'warning'} className="float-right" onClick={()=> window.open('https://trial.essentialskills.com/scope/'+componentData.programSelectedID.toLowerCase()+'.pdf', '_blank')}>Scope and Sequence</Button></Col> }
        </Row>
        <br/>
        
        <Row>
            <Col xs={8}>
                <Col xs={12}>
                    <IconEdit style={{fontWeight:'bold', color:'red'}}/> Pretest Assigned Modules  &nbsp;&nbsp; <IconEdit style={{fontWeight:'bold', color:'green'}}/> Teacher Assigned Modules
                </Col>
            </Col>
        </Row>
        <Row>
            {/* <ButtonConsole pageState={pageState} parentState={componentData}/> */}

            <Col xs={8}>{(componentData.isSaving)?            
                <Alert variant={'danger'}><Spinner/> <center>Saving...({pageState.database.queryCount})</center></Alert>:
                <Col xs={12}>
                    <StudentModulesTableComp pageState={pageState} parentState={componentData}/>
                </Col>}
            </Col> 
            {(componentData.studentsSelected.length ==0)
                ?<Col xs={4} style={{ border: '1px solid #cfcfcf'}}>
                    <TitleBar>
                        <Col>Assigning Program Modules</Col>
                    </TitleBar>
                    <br/>
                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                    <Alert variant={'success'}>To create a group assignment for multiple students, please select all students prior to selecting modules.<br/><br/>To create unique assignments, select one student at a time & save their assignment before moving onto the next student</Alert>
                    <Alert variant={'danger'}>Pre and Posttests can only be assigned for entire programs and not specific program modules.</Alert>
                </Col>
                :<Col xs={4} onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}><SideModuleTable pageState={pageState} parentState={componentData}/></Col>
            }

        </Row>

        <Row></Row>
    </>);
};

export default ContainerComp;